<setup-node [allowEdit]="true" [editing]="editing()" [displayTemplate]="displayTemplate" [editTemplate]="editTemplate">
  <ng-template #displayTemplate>
    <span class="task-package-name">{{ taskPackage().name }}</span>
  </ng-template>
  <ng-template #editTemplate>
    <div class="edit-container">
      <dx-form class="gpd-form" [formData]="taskPackage()" width="100%" [showColonAfterLabel]="false">
        <dxi-form-item dataField="name" caption="Name" i18n-text="@@name" cssClass="gpd-input">
          <dx-text-box
            class="gpd-input"
            [(value)]="taskPackage().name"
            (onValueChanged)="onDataChanged()"
            valueChangeEvent="input"
            validationMessageMode="always"
            [maxLength]="50"
          >
            <dx-validator>
              <dxi-validation-rule type="required" i18n-message="@@required" message="Required" />
              <dxi-validation-rule
                type="custom"
                [validationCallback]="uniqueNameValidationCallback"
                [reevaluate]="true"
                i18n-message="@@nameAlreadyExists"
                message="Name already Exists."
              />
            </dx-validator>
          </dx-text-box>
        </dxi-form-item>
      </dx-form>
      <div class="gpd-button-group">
        <app-svg-icon
          *ngIf="allowDelete()"
          icon="delete"
          [size]="24"
          color="var(--color-red-500)"
          class="gpd-button-icon"
          (click)="onDeleteClicked()"
        ></app-svg-icon>
      </div>
    </div>
    <dx-validator [adapter]="adapterConfig">
      <dxi-validation-rule
        type="custom"
        [validationCallback]="validationCallback"
        i18n-message="@@taskPackageConfigInvalidValidationMessage"
        message="Task package configuration is invalid"
        style="display: none"
      ></dxi-validation-rule>
    </dx-validator>
  </ng-template>
</setup-node>
